import React from 'react';
import { Card } from './ui/card';
import { Home, Square, Paintbrush, Building, Wrench } from 'lucide-react';

const iconMap = {
  Home,
  Square,
  Paintbrush,
  Building,
  Wrench
};

const ServiceCard = ({ service }) => {
  const IconComponent = iconMap[service.icon] || Home;

  return (
    <Card className="p-6 border-2 border-[#FFC222] bg-white hover:shadow-xl transition-all duration-300 hover:-translate-y-1 rounded-xl">
      <div className="flex flex-col items-center text-center">
        <div className="w-16 h-16 bg-[#FFC222] rounded-full flex items-center justify-center mb-4">
          <IconComponent className="w-8 h-8 text-black" />
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
        <p className="text-gray-600">{service.description}</p>
      </div>
    </Card>
  );
};

export default ServiceCard;
